export type SwatchDataResponse = {
  colors: SwatchDataSingle[]
  groups: { title: string, file: string, colors:string[] }[],
}
export type SwatchDataSingle = { color: string, file: string}

export interface AddedSwatchData {
    collection: {
      id: number,
      colors: SwatchDataSingle[],
      groups: SwatchDataResponse["groups"]
    }
}


export default class SwatchData {

  async get() {
    const win : typeof globalThis & AddedSwatchData = {
      collection: {
        id: -1,
        colors: [],
        groups: [],
      },
      ...window
    }
    let data = {} as SwatchDataResponse;
    if(process.env.NODE_ENV === 'development'){
      const devData = await import('./swatch-data.dev');
      data = { ...devData.swatchData }
    } else {
      data = {
        colors: win.collection && win.collection.colors ? win.collection.colors : [],
        groups: win.collection && win.collection.groups ? win.collection.groups : [],
      };
    }
    return data
  }
}